import React from 'react';
import Lenis from 'lenis';
import { ZoomParallax } from '../common/zoom-parallax';
import Image from 'next/image';

export default function LifeMowebNew() {

	React.useEffect(() => {
  const lenis = new Lenis({
    lerp: 0.08,          // smoother, less lag
    smoothWheel: true,
  });

  let rafId: number;

  const raf = (time: number) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };

  rafId = requestAnimationFrame(raf);

  return () => {
    cancelAnimationFrame(rafId);
    lenis.destroy();
  };
}, []);

	const images = [
		{
			src: '/img/aboutus/moweb-4.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-5.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-1.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-2.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-3.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-7.webp',
			alt: 'Life at Moweb',
		},
		{
			src: '/img/aboutus/moweb-6.webp',
			alt: 'Life at Moweb',
		},
	];

	return (
    <>
		<div className="section dark:bg-black section-py lg:pb-5">
            <div className="container lg:container mx-auto">
                <div className="row grid xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1">
                    <h2 className="mb-50 text-center">Life at Moweb Limited</h2>
                </div>
								<div className="row xl:hidden lg:block md:block block">
									<Image
										src="/img/aboutus/img-about-us-life-at-moweb.webp"
										width={1236}
                    height={800}
										alt="Life at Moweb"
										className='img-fluid'
									/>

								</div>
							<ZoomParallax images={images} />
						</div>
    </div>
        
    </>
        
	);
}

